"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerProfileDto = void 0;
const CustomerVehicleDto_1 = require("../customer-vehicles/CustomerVehicleDto");
const LocationDto_1 = require("../locations/LocationDto");
const LoginDto_1 = require("../logins/LoginDto");
class CustomerProfileDto {
    constructor(params) {
        this.isLoyaltyRewardsUser = false;
        this.phoneHasBeenVerified = false;
        this.emailHasBeenVerified = false;
        this.isDeleted = false;
        this.isDealervault = false;
        this.isOpentrack = false;
        if (!params) {
            return;
        }
        this.isDealervault = false;
        this.isOpentrack = false;
        this.id = params.id;
        this.locationId = params.locationId;
        this.loginId = params.loginId;
        this.firstName = params.firstName;
        this.lastName = params.lastName;
        this.email = params.email;
        this.phoneCountryCode = params.phoneCountryCode;
        this.phone = params.phone;
        this.zipCode = params.zipCode;
        this.contactPreference = params.contactPreference;
        this.rewardsNumber = params.rewardsNumber;
        this.isLoyaltyRewardsUser = params.isLoyaltyRewardsUser;
        this.authenticationCode = params.authenticationCode;
        this.authenticationCodeExpiresAt = params.authenticationCodeExpiresAt;
        this.authorizationToken = params.authorizationToken;
        this.phoneHasBeenVerified = params.phoneHasBeenVerified;
        this.emailHasBeenVerified = params.emailHasBeenVerified;
        this.customData = params.customData;
        this.isDeleted = params.isDeleted;
        this.deletedAt = params.deletedAt;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.isDealervault !== undefined) {
            this.isDealervault = params.isDealervault;
        }
        if (params.isOpentrack !== undefined) {
            this.isOpentrack = params.isOpentrack;
        }
        if (params.location !== undefined) {
            this.location = params.location === null ?
                null :
                new LocationDto_1.LocationDto(params.location);
        }
        if (params.login !== undefined) {
            this.login = params.login === null ?
                null :
                new LoginDto_1.LoginDto(params.login);
        }
        if (params.customerVehicles !== undefined) {
            this.customerVehicles = !params.customerVehicles ?
                [] :
                params.customerVehicles.map((customerVehicleDto) => new CustomerVehicleDto_1.CustomerVehicleDto(customerVehicleDto));
        }
    }
}
exports.CustomerProfileDto = CustomerProfileDto;
//# sourceMappingURL=CustomerProfileDto.js.map